import { DateTime } from 'luxon';
import { SavedFilterResponse } from '@services/api-client/responses';
import { EMPTY_FILTER } from 'app/features/shared/component/filter/filter-model';

export const SYSTEM_FILTER_ID_PREFIX = '__system__';
export const CURRENT_LIST_FILTER_ID = `${SYSTEM_FILTER_ID_PREFIX}current-list-filter`;
export const CURRENT_YEAR_FILTER_ID = `${SYSTEM_FILTER_ID_PREFIX}current-year`;

export function buildSystemFilters(names: {
    currentMonth: string;
    previousMonth: string;
    currentYear: string;
}): SavedFilterResponse[] {
    const now = DateTime.now();
    return [
        {
            id: `${SYSTEM_FILTER_ID_PREFIX}current-month`,
            name: names.currentMonth,
            filter: JSON.stringify({
                ...EMPTY_FILTER,
                captureDateRange: {
                    from: now.startOf('month').toISO(),
                    to: now.endOf('month').toISO()
                }
            })
        },
        {
            id: `${SYSTEM_FILTER_ID_PREFIX}previous-month`,
            name: names.previousMonth,
            filter: JSON.stringify({
                ...EMPTY_FILTER,
                captureDateRange: {
                    from: now.minus({ months: 1 }).startOf('month').toISO(),
                    to: now.minus({ months: 1 }).endOf('month').toISO()
                }
            })
        },
        {
            id: `${SYSTEM_FILTER_ID_PREFIX}current-year`,
            name: names.currentYear,
            filter: JSON.stringify({
                ...EMPTY_FILTER,
                captureDateRange: {
                    from: now.startOf('year').toISO(),
                    to: now.endOf('year').toISO()
                }
            })
        }
    ];
}
